"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupLoom = setupLoom;
const path = __importStar(require("path"));
const os = __importStar(require("os"));
async function setupLoom(input, deps) {
    const loomPath = input.path || path.join(os.homedir(), 'looms', input.name);
    if (deps.fs.existsSync(loomPath)) {
        throw new Error(`Directory already exists: ${loomPath}`);
    }
    deps.fs.ensureDirSync(path.join(loomPath, '.loom', 'templates'));
    deps.fs.ensureDirSync(path.join(loomPath, '.loom', 'prompts'));
    deps.fs.ensureDirSync(path.join(loomPath, '.loom', 'schemas'));
    deps.fs.ensureDirSync(path.join(loomPath, '.loom', 'cache'));
    deps.fs.ensureDirSync(path.join(loomPath, 'loom'));
    deps.fs.ensureDirSync(path.join(loomPath, 'loom', 'refs'));
    try {
        deps.registry.addLoom(input.name, loomPath);
    }
    catch (e) {
        if (e.message.includes('already exists')) {
            throw new Error(`Loom '${input.name}' is already registered. Use 'loom switch ${input.name}'.`);
        }
        throw e;
    }
    const shouldSwitch = input.switch !== false;
    if (shouldSwitch) {
        deps.registry.setActiveLoom(input.name);
    }
    return { path: loomPath, name: input.name, activated: shouldSwitch };
}
